<!--
  ~ Copyright The Linux Foundation and each contributor to LFX.
  ~ SPDX-License-Identifier: MIT
-->
<div class="circle-wrap" [style]="{ height: size === '' ? undefined : size, width: size === '' ? undefined : size }">
  <div [id]="chartName" class="chart"></div>
</div>
